const indexItems = [
  { label: '国产热播', icon: 'ri-fire-line', count: '586部', desc: '《繁花》《狂飙》等口碑国剧' },
  { label: '韩剧精选', icon: 'ri-heart-line', count: '423部', desc: '《黑暗荣耀》等话题韩剧' },
  { label: '美剧专区', icon: 'ri-global-line', count: '315部', desc: 'HBO、Netflix高分剧集' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '268部', desc: '《他是谁》《白夜追凶》系列' },
  { label: '古装仙侠', icon: 'ri-moon-line', count: '192部', desc: '国风美学沉浸式观剧体验' },
  { label: '日剧频道', icon: 'ri-sun-line', count: '156部', desc: '温情治愈与职场剧集' },
  { label: '经典重温', icon: 'ri-vip-crown-line', count: '340部', desc: '《甄嬛传》等常看常新神作' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-folder-open-line text-primary-500 text-sm"></i>
            <span className="text-primary-400 text-xs font-medium">剧集分类</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">专题合集索引</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            七大分类频道帮你精准定位想看的剧集，总有一款合你口味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className={`bg-background-100 border border-background-200/60 rounded-xl p-5 hover:border-primary-500/20 transition-all cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15 mb-3">
                <i className={`${item.icon} text-primary-500 text-lg`}></i>
              </div>
              <h4 className="text-foreground-800 font-heading font-bold text-sm mb-1">{item.label}</h4>
              <p className="text-foreground-500 text-xs mb-2">{item.desc}</p>
              <span className="text-primary-500 text-xs font-semibold">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}